export default {
    routerName: '岗位新增',
    post: {
        name: '岗位名',
        code: '岗位号',
        sortOrder: '排序',
        status: '状态',
        open: '启用',
        close: '停用',
        remark: '备注',
    },
};
